// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"316":"0fc4d0db","455":"daeebe46","879":"89ed090f","977":"2080303e"}[chunkId] + ".chunk.js";
};